import { render, staticRenderFns } from "./CreateActivity.vue?vue&type=template&id=8c2f856e&scoped=true"
import script from "./CreateActivity.vue?vue&type=script&lang=js"
export * from "./CreateActivity.vue?vue&type=script&lang=js"
import style0 from "./CreateActivity.vue?vue&type=style&index=0&id=8c2f856e&prod&lang=less&scoped=true"
import style1 from "./CreateActivity.vue?vue&type=style&index=1&id=8c2f856e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f856e",
  null
  
)

export default component.exports